module.exports = __webpack_public_path__ + "img/maintenance_cancel.3b0c1057.svg";